import { EventEmitter, Input, Output } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'clink-no-data',
    template: `
        <div id="no-data">
            <div class="content">
                <i class="iconfont icon-kongshuju ticketiconfont ticket-icon-kongshuju"></i>
                <p>
                    <span class="content-color">{{ title }}</span>
                    <span *ngIf="linkName" class="link" (click)="linkClick()">{{ linkName }}</span>
                </p>
                <button *ngIf="hasBtn" nz-button nzType="primary" (click)="btnClick()">
                    {{ btnName }}
                </button>
            </div>
        </div>
    `,
    styles: [
        `
            #no-data {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            #no-data .content {
                text-align: center;
            }
            #no-data .content p {
                margin: 10px 0;
            }
            #no-data .content i {
                font-size: 64px;
            }
            #no-data .content .content-color {
                color: #8c8c8c;
            }
            #no-data .content .link {
                padding-left: 10px;
                cursor: pointer;
                color: #4385ff;
            }
        `,
    ],
})
export class NoDataComponent {
    @Input() title? = '暂无数据'; // 无数据时提示文本
    @Input() linkName? = null; // 跳转的链接名称
    @Input() hasBtn? = false; // 是否有按钮
    @Input() btnName = '去编辑'; // 按钮名称
    @Output() linkEmit = new EventEmitter(); // 点击链接冒泡
    @Output() btnEmit = new EventEmitter(); // 点击按钮冒泡

    constructor() {}

    /**
     * 点击链接
     *
     * @memberof NoDataComponent
     */
    linkClick(): void {
        this.linkEmit.emit();
    }

    btnClick(): void {
        this.btnEmit.emit();
    }
}
